exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video_bg {\n  height: 100%;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  width: 100%; }\n  .video_bg video {\n    height: 100%;\n    object-fit: cover;\n    width: 100%; }\n", ""]);

// exports
